import { getMessage } from '@tcc/i18n';
import { getApplicationLocaleGroup, getApplicationAmountLocaleGroup } from '../../../utils/newProcessUnits';
import { localizeUnits } from '../../../utils/processUnits';
import { LocaleGroup } from '../../../types/Common';
import styles from './ApplicationsPanel.css';

interface ApplicationMetricsProps {
  area: { q: number; u: string };
  applicationRate: { q: number; u: string };
  totalAmountApplied: { q: number; u: string };
  machineSpeed: { q: number; u: string };
}

const renderMeasurement = (
  measurement: { q: number; u: string },
  options: { localeGroup?: LocaleGroup | string } = {},
) => {
  const localized = localizeUnits(measurement.q, { key: measurement.u, ...options });
  return (
    <>
      <span className={styles.applicationsPanelValueText}>{localized.q}</span>{' '}
      <span className={styles.applicationsPanelUnitText}>{localized.u}</span>
    </>
  );
};

const ApplicationMetrics = ({
  area,
  applicationRate,
  totalAmountApplied,
  machineSpeed,
}: ApplicationMetricsProps) => (
  <div className={styles.applicationsPanelMetrics}>
    <div className={styles.applicationsPanelMetricRow} data-test-id="application-card-metrics-area">
      <span className={styles.applicationsPanelMetricLabel}>
        {getMessage('application.details.area')}
      </span>
      <span className={styles.applicationsPanelMetricDots} />
      <span className={styles.applicationsPanelMetricValue}>
        {renderMeasurement(area, { localeGroup: LocaleGroup.AREA })}
      </span>
    </div>
    <div className={styles.applicationsPanelMetricRow} data-test-id="application-card-metrics-rate">
      <span className={styles.applicationsPanelMetricLabel}>
        {getMessage('application.details.rate')}
      </span>
      <span className={styles.applicationsPanelMetricDots} />
      <span className={styles.applicationsPanelMetricValue}>
        {(() => {
          const rateLocaleGroup = getApplicationLocaleGroup(applicationRate.u);
          return renderMeasurement(applicationRate, { localeGroup: rateLocaleGroup });
        })()}
      </span>
    </div>
    <div className={styles.applicationsPanelMetricRow} data-test-id="application-card-metrics-total-amount">
      <span className={styles.applicationsPanelMetricLabel}>
        {getMessage('application.details.total.amount')}
      </span>
      <span className={styles.applicationsPanelMetricDots} />
      <span className={styles.applicationsPanelMetricValue}>
        {(() => {
          const totalLocaleGroup = getApplicationAmountLocaleGroup(totalAmountApplied.u);
          return renderMeasurement(totalAmountApplied, { localeGroup: totalLocaleGroup });
        })()}
      </span>
    </div>
    <div className={styles.applicationsPanelMetricRow} data-test-id="application-card-metrics-speed">
      <span className={styles.applicationsPanelMetricLabel}>
        {getMessage('application.details.speed')}
      </span>
      <span className={styles.applicationsPanelMetricDots} />
      <span className={styles.applicationsPanelMetricValue}>
        {renderMeasurement(machineSpeed, { localeGroup: LocaleGroup.EQUIPMENT_SPEED })}
      </span>
    </div>
  </div>
);

export default ApplicationMetrics;
export type { ApplicationMetricsProps };
